import { Message, MessageType } from 'domain-entities';

export const checkMessageType = (message: Message, ...messageTypes: MessageType[]) =>
	messageTypes.includes(message.messageType);
